module.exports = __webpack_public_path__ + "img/authForteKoTechnique.92ae3962.png";